<ng-container [ngSwitch]="true">
    <ng-container
        *ngSwitchCase="
            env.USE_TAILWIND &&
            (env.THEME_NAME === themeFeature.PILET ||
                env.THEME_NAME === themeFeature.GOTLAND_V2 ||
                env.THEME_NAME === themeFeature.PANEVEZYS ||
                env.THEME_NAME === themeFeature.PEUTK ||
                env.THEME_NAME === themeFeature.SORMLAND_V2 ||
                env.THEME_NAME === themeFeature.KOHTLAJARVE ||
                env.THEME_NAME === themeFeature.OREBRO ||
                env.THEME_NAME === themeFeature.VARMLAND ||
                env.THEME_NAME === themeFeature.TALLINN ||
                env.THEME_NAME === themeFeature.TARTU_APP)
        ">
        <gl-home-page-stw></gl-home-page-stw>
    </ng-container>

    <ng-container *ngSwitchCase="env.THEME_NAME === themeFeature.VL">
        <div class="block--content-landing-page remove-margin-bottom block" id="main-content">
            <div class="block--wrap wrap-max-width-1054px block">
                <rwidget-alert></rwidget-alert>

                <div class="ticket">
                    <div class="block-landing-page-content flex">
                        <div class="flex-left block-landing-page-content__item">
                            <div>
                                <img
                                    class="hide-for-wcag"
                                    alt=""
                                    src="{{ assetsPath$ | async }}/landing-item-image-1.png" />
                                <img
                                    class="show-high-contrast-view"
                                    alt=""
                                    src="{{ assetsPath$ | async }}/landing-item-image-1-wcag.png" />
                            </div>

                            <div class="block-landing-page-content__text">
                                <button
                                    class="btn btn--primary width-180 full-width-mobile margin-bottom-20"
                                    *ngIf="!ridangoAuth.getLoginStatus()"
                                    [routerLink]="'/login' | localize">
                                    {{ 'LANDING_PAGE_LOGIN' | translate }}
                                </button>
                                <button
                                    class="btn btn--primary width-180 full-width-mobile margin-bottom-20"
                                    *ngIf="ridangoAuth.getLoginStatus()"
                                    [routerLink]="'/account' | localize">
                                    <!-- TODO: remove LEGACY_LANDING_PAGE_ACCOUNT key and this condition once OLD_WEB is fully deprecated -->
                                    {{
                                        (env?.OLD_WEB ? 'LEGACY_LANDING_PAGE_ACCOUNT' : 'LANDING_PAGE_ACCOUNT')
                                            | translate
                                    }}
                                </button>
                                <p
                                    class="remove-margin"
                                    innerHtml="{{ 'LANDING_PAGE_LINKS' | translate }}"
                                    ridangoTranslatedLink></p>
                            </div>
                        </div>

                        <div class="flex-left block-landing-page-content__item">
                            <div class="">
                                <img
                                    class="hide-for-wcag"
                                    alt=""
                                    src="{{ assetsPath$ | async }}/landing-item-image-2.png" />
                                <img
                                    class="show-high-contrast-view"
                                    alt=""
                                    src="{{ assetsPath$ | async }}/landing-item-image-2-wcag.png" />
                            </div>

                            <div class="block-landing-page-content__text">
                                <button
                                    class="btn btn--primary width-180 full-width-mobile margin-bottom-20"
                                    [routerLink]="'/purchase/ticket' | localize">
                                    {{ 'LANDING_PAGE_BTN_BUY_AFTER_LOGIN' | translate }}
                                </button>

                                <p class="remove-margin" innerHtml="{{ 'LANDING_PAGE_TICKETS' | translate }}"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="block--bg-main-image-wrapper-landing-page block"></div>
        </div>
    </ng-container>

    <ng-container *ngSwitchDefault>
        <div class="block--content-landing-page block" id="main-content">
            <div class="block--wrap block">
                <div class="ticket">
                    <div class="block-left-item-landing-page-content">
                        <div class="block-left-item-landing-page-content__img-wrapper">
                            <img class="hide-for-wcag" alt="" src="{{ assetsPath$ | async }}/landing-small-image.png" />
                            <img
                                class="show-high-contrast-view"
                                alt=""
                                src="{{ assetsPath$ | async }}/landing-small-image-wcag.png" />
                        </div>
                    </div>

                    <div class="block-right-item-landing-page-content">
                        <h2 class="margin-bottom-20">{{ 'LANDING_PAGE_H2_CREATE_ACCOUNT' | translate }}</h2>

                        <ul
                            class="block-right-item-landing-page-content__list remove-padding"
                            innerHtml="{{ 'LANDING_PAGE_POINTS' | translate }}"></ul>

                        <button
                            class="btn btn--primary width-180 full-width-mobile margin-top-30"
                            *ngIf="!ridangoAuth.getLoginStatus()"
                            [routerLink]="'/register' | localize">
                            {{ 'HEADER_SECONDARY_NAV_LOGIN' | translate }}
                        </button>
                        <button
                            class="btn btn--primary width-180 full-width-mobile margin-top-30"
                            *ngIf="ridangoAuth.getLoginStatus()"
                            [routerLink]="'/account' | localize">
                            {{ 'HEADER_MY_ACCOUNT' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</ng-container>
